(function () {
  if (window.wlyLearnReady) return;
  window.wlyLearnReady = true;
  var cache = {};
  function getCount(url) {
    if (cache[url]) return cache[url];
    var key = 'wly-count:' + url;
    var saved = null;
    try {
      saved = window.sessionStorage.getItem(key);
    } catch (e) {}
    if (saved !== null) {
      cache[url] = Promise.resolve(saved);
      return cache[url];
    }
    cache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (t) {
        var n = String(t).replace(/[^0-9]/g, '');
        try {
          if (n) window.sessionStorage.setItem(key, n);
        } catch (e) {}
        return n;
      })
      .catch(function () {
        return '';
      });
    return cache[url];
  }
  function initCounts(root) {
    var els = root.querySelectorAll('[data-wly-tag-count]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        if (el.wlyDone) return;
        el.wlyDone = true;
        getCount(el.getAttribute('data-wly-tag-count')).then(function (n) {
          if (!n) return;
          var one = el.getAttribute('data-one') || '';
          var many = el.getAttribute('data-many') || '[count]';
          el.textContent = (n === '1' && one ? one : many).replace('[count]', n);
          el.hidden = false;
        });
      })(els[i]);
    }
  }
  function initScrollers(root) {
    var tracks = root.querySelectorAll('[data-wly-lscroll]');
    for (var i = 0; i < tracks.length; i++) {
      (function (track) {
        if (track.wlyDone) return;
        track.wlyDone = true;
        var arrow = track.parentNode.querySelector('[data-wly-lscroll-arrow]');
        var back = track.parentNode.querySelector('[data-wly-lscroll-prev]');
        if (!arrow) return;
        function update() {
          var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
          arrow.hidden = end;
          if (back) back.hidden = track.scrollLeft <= 8;
        }
        function go(dir) {
          var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: still ? 'auto' : 'smooth' });
        }
        arrow.addEventListener('click', function () {
          go(1);
        });
        if (back) {
          back.addEventListener('click', function () {
            go(-1);
          });
        }
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      })(tracks[i]);
    }
  }
  function initVideos(root) {
    var lists = root.querySelectorAll('[data-wly-vlib]');
    for (var i = 0; i < lists.length; i++) {
      (function (lib) {
        if (lib.wlyDone) return;
        lib.wlyDone = true;
        var chips = lib.querySelectorAll('[data-wly-vchip]');
        var cards = lib.querySelectorAll('[data-wly-vcard]');
        var feat = lib.querySelector('[data-wly-vfeat]');
        var count = lib.querySelector('[data-wly-vcount]');
        function setFeatured(card) {
          if (!feat || !card) return;
          var media = feat.querySelector('[data-wly-vfeat-media]');
          var thumb = card.querySelector('[data-wly-vthumb]');
          if (media) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'wly-vlib__play';
            btn.setAttribute('data-wly-yt', card.getAttribute('data-id'));
            btn.setAttribute('aria-label', card.getAttribute('data-play'));
            btn.innerHTML = thumb ? thumb.innerHTML : '';
            media.innerHTML = '';
            media.appendChild(btn);
          }
          var by = feat.querySelector('[data-wly-vfeat-by]');
          var title = feat.querySelector('[data-wly-vfeat-title]');
          if (by) by.textContent = card.getAttribute('data-by');
          if (title) title.textContent = card.getAttribute('data-title');
        }
        function apply(creator) {
          var shown = [];
          for (var c = 0; c < cards.length; c++) {
            var match = creator === 'all' || cards[c].getAttribute('data-by-key') === creator;
            cards[c].hidden = !match;
            if (match) shown.push(cards[c]);
          }
          if (shown.length) {
            setFeatured(shown[0]);
            shown[0].hidden = true;
          }
          if (feat) feat.hidden = !shown.length;
          if (count) {
            var tpl = shown.length === 1 ? count.getAttribute('data-one') : count.getAttribute('data-many');
            count.textContent = String(tpl || '').replace('[count]', shown.length);
          }
          for (var k = 0; k < chips.length; k++) chips[k].setAttribute('aria-pressed', chips[k].getAttribute('data-wly-vchip') === creator ? 'true' : 'false');
        }
        for (var j = 0; j < chips.length; j++) {
          chips[j].addEventListener('click', function (e) {
            apply(e.currentTarget.getAttribute('data-wly-vchip'));
          });
        }
        if (cards.length) apply('all');
      })(lists[i]);
    }
  }
  function syncClear(field) {
    var form = field.closest('[data-wly-lsearch]');
    var btn = form ? form.querySelector('[data-wly-lsearch-clear]') : null;
    if (btn) btn.hidden = !field.value;
  }
  function resetGuides() {
    var box = document.querySelector('[data-wly-lg]');
    if (!box) return;
    var results = box.querySelector('[data-wly-lg-results]');
    var empty = box.querySelector('[data-wly-lg-empty]');
    var normal = box.querySelector('[data-wly-lg-default]');
    var count = box.querySelector('[data-wly-lg-count]');
    if (!results || !normal || results.hidden) return;
    results.hidden = true;
    results.innerHTML = '';
    if (empty) empty.hidden = true;
    normal.hidden = false;
    if (count && count.wlyOriginal !== undefined) count.textContent = count.wlyOriginal;
  }
  function initSearchFields(root) {
    var fields = root.querySelectorAll('[data-wly-lsearch] input[name="q"]');
    for (var i = 0; i < fields.length; i++) {
      (function (field) {
        if (field.wlyDone) return;
        field.wlyDone = true;
        var desk = field.getAttribute('placeholder');
        var mob = field.getAttribute('data-placeholder-mobile');
        if (mob && window.matchMedia) {
          var mq = window.matchMedia('(max-width: 749px)');
          var setPh = function () {
            field.setAttribute('placeholder', mq.matches ? mob : desk);
          };
          setPh();
          if (mq.addEventListener) mq.addEventListener('change', setPh);
          else if (mq.addListener) mq.addListener(setPh);
        }
        field.addEventListener('input', function () {
          syncClear(field);
        });
        syncClear(field);
      })(fields[i]);
    }
  }
  function guidesSearch(form) {
    var box = document.querySelector('[data-wly-lg]');
    if (!box) return false;
    var input = form.querySelector('input[name="q"]');
    var q = input ? input.value.replace(/^\s+|\s+$/g, '') : '';
    var results = box.querySelector('[data-wly-lg-results]');
    var empty = box.querySelector('[data-wly-lg-empty]');
    var normal = box.querySelector('[data-wly-lg-default]');
    var count = box.querySelector('[data-wly-lg-count]');
    if (!results || !normal || !count) return false;
    if (count.wlyOriginal === undefined) count.wlyOriginal = count.textContent;
    function scrollToList() {
      var top = box.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    if (!q) {
      results.hidden = true;
      results.innerHTML = '';
      if (empty) empty.hidden = true;
      normal.hidden = false;
      count.textContent = count.wlyOriginal;
      scrollToList();
      return true;
    }
    form.setAttribute('aria-busy', 'true');
    var url = (box.getAttribute('data-search-url') || '/search') + '?q=' + encodeURIComponent(q) + '&type=article&options%5Bprefix%5D=last&section_id=wly-learn-search';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('search');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-wly-lg-found] ul');
        var n = list ? list.querySelectorAll('li').length : 0;
        var total = list ? parseInt(list.getAttribute('data-count'), 10) || n : 0;
        normal.hidden = true;
        results.innerHTML = n ? list.outerHTML : '';
        if (total > n) {
          var more = document.createElement('a');
          more.className = 'wly-lg__all';
          more.href = (box.getAttribute('data-search-url') || '/search') + '?q=' + encodeURIComponent(q) + '&type=article&options%5Bprefix%5D=last&tab=article';
          var segs = (box.getAttribute('data-all-label') || 'See all [count] guides').replace('[count]', total).split('\u2192');
          var tpl = box.querySelector('[data-wly-lg-arrow]');
          for (var x = 0; x < segs.length; x++) {
            if (x && tpl) more.appendChild(tpl.content.cloneNode(true));
            more.appendChild(document.createTextNode(segs[x]));
          }
          results.appendChild(more);
          n = total;
        }
        results.hidden = !n;
        if (empty) empty.hidden = !!n;
        var tpl = n === 1 ? count.getAttribute('data-found-one') : count.getAttribute('data-found-many');
        count.textContent = String(tpl || '[count]').replace('[count]', n);
        form.removeAttribute('aria-busy');
        scrollToList();
      })
      .catch(function () {
        form.removeAttribute('aria-busy');
        form.submit();
      });
    return true;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-wly-lsearch]') : null;
    if (!form) return;
    if (document.querySelector('[data-wly-lg]')) {
      e.preventDefault();
      guidesSearch(form);
    }
  });
  document.addEventListener('click', function (e) {
    var play = e.target.closest ? e.target.closest('[data-wly-yt]') : null;
    if (play) {
      var id = play.getAttribute('data-wly-yt');
      if (!id) return;
      e.preventDefault();
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      frame.title = play.getAttribute('aria-label') || 'Video';
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      frame.className = 'wly-yt__frame';
      play.parentNode.replaceChild(frame, play);
      return;
    }
    var clr = e.target.closest ? e.target.closest('[data-wly-lsearch-clear]') : null;
    if (clr) {
      var cform = clr.closest('[data-wly-lsearch]');
      var cin = cform ? cform.querySelector('input[name="q"]') : null;
      if (cin) {
        cin.value = '';
        syncClear(cin);
        resetGuides();
        cin.focus();
      }
      return;
    }
    var chip = e.target.closest ? e.target.closest('[data-wly-lsearch-chip]') : null;
    if (chip) {
      var field = document.getElementById(chip.getAttribute('aria-controls'));
      if (field) {
        field.value = chip.getAttribute('data-wly-lsearch-chip');
        syncClear(field);
        field.focus();
      }
      return;
    }
    var watch = e.target.closest ? e.target.closest('[data-wly-vplay]') : null;
    if (watch) {
      var box = watch.closest('[data-wly-vfeat]');
      var btn = box ? box.querySelector('[data-wly-yt]') : null;
      if (btn) btn.click();
      return;
    }
    var copy = e.target.closest ? e.target.closest('[data-wly-copy-link]') : null;
    if (copy) {
      e.preventDefault();
      var url = copy.getAttribute('data-wly-copy-link') || window.location.href;
      var done = function () {
        var label = copy.getAttribute('data-done');
        if (!label) return;
        var old = copy.textContent;
        copy.textContent = label;
        window.setTimeout(function () {
          copy.textContent = old;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, done);
      } else {
        var input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand('copy');
        } catch (err) {}
        document.body.removeChild(input);
        done();
      }
    }
  });
  function init(root) {
    initSearchFields(root);
    initCounts(root);
    initScrollers(root);
    initVideos(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
